import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import { DeliveryCompany } from "modules/deliveryCompanies";

import { COMPANY_ME_QUERY_KEY } from "../useGetCurrentManager/useGetCurrentManager";
import {
  UpdateCompanySettingsRequest,
  requestUpdateCompanySettings
} from "./updateCompanySettings.request";

const useUpdateCompanySettings = (
  options?: MutationOptions<DeliveryCompany, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateCompanySettingsRequest) =>
      requestUpdateCompanySettings(body),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: [COMPANY_ME_QUERY_KEY] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateCompanySettings;
